import { memo } from "react";
import { Paper, Typography } from "@mui/material";
import { makeStyles } from "components/providers/makeStyles";

import { LivePill } from "./badges/LivePill";
import { ScheduledTime } from "./badges/ScheduledTime";
import { T } from "../../util/t";
import { useQuery } from "@apollo/client";
import { GET_HEAT } from "../../../graphql/heat";
import { CompactHeatHeader } from "./CompactHeatHeader";
import { AvatarGroup } from "../avatar/AvatarGroup";

const useStyles = makeStyles(theme => ({
    card: {
        padding: theme.spacing(1, 2),
        marginBottom: theme.spacing(1),
        cursor: "pointer",
        border: `2px solid ${theme.palette.border.light}`,
    },
    time: {
        display: "flex",
        alignItems: "center",
        textTransform: "uppercase",
    },
    title: {
        margin: theme.spacing(1, 0)
    }
}));
export const HeatSnippet = memo(({ heat, displayPodium }) => {
    const classes = useStyles();
    const isFinished = !!heat.endTime,
        isLive = !isFinished && !!heat.startTime,
        isUpcoming = !isFinished && !isLive;

    const { data } = useQuery(GET_HEAT, { variables: { id: heat.id } }),
        fullHeat = data && data.heat && { ...heat, ...data.heat };

    return (
        <Paper variant="outlined" className={classes.card}>
            <Typography variant="label2" component="section" className={classes.time}>
                {displayPodium &&
                <Typography color="textSecondary">
                    <T>{heat.podium}</T>&nbsp;:&nbsp;
                </Typography>}

                {isLive && <LivePill heat={heat}/>}
                {isUpcoming && <ScheduledTime heat={heat}/>}
            </Typography>

            <CompactHeatHeader className={classes.title} displayNumber={true} heat={heat}/>

            {fullHeat && <AvatarGroup competitors={fullHeat.competitors}/>}
        </Paper>
    );
});
